import { CommonModule } from '@angular/common'
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { AdalService } from 'ng2-adal/dist/core';
import { AuthGuard } from './guards/auth-guard';

import { DeviceDetectorModule } from 'ngx-device-detector';

import { AppBanner, AppTileView, BrowserNotSupportedView, HomeView, Login, Logout, QuickLaunch } from './components';
import { AppConfigService, AppService, AzureClient, IdentityService, MessageRelayService, PreloadSelectedModules, QuickLaunchService } from './services';

@NgModule({
    imports: [
        CommonModule,
        DeviceDetectorModule.forRoot(),
        MatFormFieldModule,
        MatIconModule,
        MatSelectModule,
        MatToolbarModule,
        RouterModule,
    ],
    exports: [
        AppBanner,
        AppTileView,
        BrowserNotSupportedView,
        HomeView,
        QuickLaunch,
    ],
    declarations: [
        AppBanner,
        AppTileView,
        BrowserNotSupportedView,
        HomeView,
        Login,
        Logout,
        QuickLaunch,
    ]
})

export class CoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [
                AdalService,
                AppConfigService,
                AppService,
                AuthGuard,
                AzureClient,
                IdentityService,
                MessageRelayService,
                PreloadSelectedModules,
                QuickLaunchService,
            ]
        };
    }
}